export enum A11tPosition {
    START_TOP = 'start top',
    START_BOTTOM = 'start bottom',
    START_CENTER = 'start center',
    END_TOP = 'end top',
    END_BOTTOM = 'end bottom',
    END_CENTER = 'end center'
}
